import '@/stores/video_settings';
import '@/components/paused_banner_ad';
import '@/components/video_timeline';
import '@/components/video_toggle_more';
import '@/components/playlist_modal';

import { appStore } from '@/stores/app';
import { getRecommendationStore } from '@/stores/recommendation';

import { appendAffiliateTrackingParams } from '../video/affiliate_tracking';
import { ABTestClickTracker } from './ab_test_click_tracker';
import type { VideoPageSiteData } from './types';
import { VideoPage } from './video';

const recommendationStore = getRecommendationStore();
const siteData: VideoPageSiteData = appStore.getPageData<VideoPageSiteData>();
const abTestClickTracker = new ABTestClickTracker(siteData.videoId);

appendAffiliateTrackingParams();

const videoPage = new VideoPage(recommendationStore, siteData, abTestClickTracker);

Alpine.data('videoPage', () => videoPage);
